import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const financingTypeApi = generateNomenApi(`/nomen/financing-type`);

export const financingTypeOptions = generateNomenOptions('financing-type', financingTypeApi);
